const prefix = 'cvf-admin/credits/';

export const GET_CREDITS = `${prefix}GET_CREDITS`;
export const GET_CREDITS_SUCCESS = `${prefix}GET_CREDITS_SUCCESS`;
export const GET_CREDITS_ERROR = `${prefix}GET_CREDITS_ERROR`;

export const ACTIVATE_CREDIT = `${prefix}ACTIVATE_CREDIT`;
export const ACTIVATE_CREDIT_SUCCESS = `${prefix}ACTIVATE_CREDIT_SUCCESS`;
export const ACTIVATE_CREDIT_ERROR = `${prefix}ACTIVATE_CREDIT_ERROR`;

export const SCHEDULE_CREDIT = `${prefix}SCHEDULE_CREDIT`;
export const SCHEDULE_CREDIT_SUCCESS = `${prefix}SCHEDULE_CREDIT_SUCCESS`;
export const SCHEDULE_CREDIT_ERROR = `${prefix}SCHEDULE_CREDIT_ERROR`;
